const MAX_DIGITS = 15;

/** Peso chileno: miles con punto y sin decimales. Vacío se queda vacío. */
export function formatChileanPeso(value: unknown): string {
  const raw = String(value ?? '')
    .trim()
    .replace(/\$/g, '')
    .replace(/\s/g, '');
  if (!raw) return '';

  const integerSide = raw.split(',')[0] ?? '';
  let digits = integerSide.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
  if (!digits) return '';
  if (digits.length > MAX_DIGITS) digits = digits.slice(0, MAX_DIGITS);
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function digitsBeforeChileanPesoCaret(raw: string, caret: number): number {
  const head = raw.slice(0, Math.max(0, caret));
  const integerSide = head.split(',')[0] ?? '';
  return integerSide.replace(/\D/g, '').length;
}

export function chileanPesoCaret(formatted: string, digitsBeforeCaret: number): number {
  if (digitsBeforeCaret <= 0) return 0;
  let seen = 0;
  for (let index = 0; index < formatted.length; index += 1) {
    const code = formatted.charCodeAt(index);
    if (code < 48 || code > 57) continue;
    seen += 1;
    if (seen === digitsBeforeCaret) return index + 1;
  }
  return formatted.length;
}
